import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { QueryClientProvider } from 'react-query';
import { I18nextProvider } from 'react-i18next';
import { SnackbarProvider } from 'notistack';
import DateFnsUtils from '@date-io/date-fns';
import CssBaseline from '@material-ui/core/CssBaseline';
import { StylesProvider, MuiThemeProvider, jssPreset } from '@material-ui/core/styles';
import rtl from 'jss-rtl';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import reportWebVitals from './reportWebVitals';
import { AppTheme } from './styles/themes';
import Routes from './routes';
import store from './store';
import { queryClient } from 'api/query';
import { MessageSender } from 'features/message/components/message-sender';

import i18n from 'locales/i18n';

import 'styles/fonts.css';

/* Slick carousel styles */
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { create } from 'jss';
import Analytics from 'analytics';

const App = () => {
  useEffect(() => {
    document.dir = i18n.dir();
    document.body.dir = i18n.dir();
    document.body.lang = i18n.language;
  }, []);

  const jss = create({ plugins: [...jssPreset().plugins, rtl()] });

  return (
    <>
      <Analytics />
      <I18nextProvider i18n={i18n}>
        <Provider store={store}>
          <QueryClientProvider client={queryClient}>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <CssBaseline>
                <SnackbarProvider maxSnack={3}>
                  <BrowserRouter>
                    <MuiThemeProvider theme={AppTheme}>
                      <StylesProvider jss={jss}>
                        <Routes />
                      </StylesProvider>
                    </MuiThemeProvider>
                    <MessageSender />
                  </BrowserRouter>
                </SnackbarProvider>
              </CssBaseline>
            </MuiPickersUtilsProvider>
          </QueryClientProvider>
        </Provider>
      </I18nextProvider>
    </>
  );
};

ReactDOM.render(<App />, document.getElementById('root'));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
